import {useTranslation} from "react-i18next";

export function EntityItem({entity, LinkFactory}){
  const {id, img, name} = entity;

  let entity_img;
  if(img === undefined || img === null){
    entity_img = <span className="c-entities_img-replace">{name[0].toUpperCase()}</span>
  }else{
    entity_img = <img alt="" className="c-entities_img" style={{width: "50px", height: "50px"}} src={img} />
  }

  return (
    <LinkFactory id={id} type={"entity"}>
      <div className={`c-entities ${id}`}>
        {entity_img}
        <div className="c-infos">
          <p>{name}</p>
        </div>
      </div>
    </LinkFactory>
  )
}

function sortEntities(data){
  return data.sort(function(a,b){

    var nameA = a.name.toUpperCase().replace('É','E');
    var nameB = b.name.toUpperCase().replace('É','E');

    if(nameA > nameB){
      return 1;
    }
    if( nameA < nameB){
      return -1;
    }
    return 0;
  });
}

export function EntitiesListClassic({entities, LinkFactory}){
    const { t } = useTranslation();
    let data = sortEntities(entities);

  if(data.length === 0) {
    return (
        <>
            <p>{t('Aucun élément à afficher')}</p>
        </>
    )
    }
    return (
        <>
          <div className="c-entities_list-letter title">
            {data.map(i => <EntityItem key={i.id} entity={i} LinkFactory={LinkFactory} />)}
          </div>
        </>
    )
}

export function EntitieList({entities, LinkFactory}){
  const { t } = useTranslation();
  let data = sortEntities(entities);
  if(data.length === 0){
    return (
      <>
        <p>{t('Aucun élément à afficher')}</p>
      </>
    )
  }else{
    let firstLetter = data[0].name.charAt(0).toUpperCase();

    let entitiesGrp = [{letter: firstLetter,data:[]}];
    data.map((item)=>{
      let titleLetter = item.name[0].toUpperCase().replace('É','E');
      if(firstLetter.toUpperCase() !== titleLetter.toUpperCase()){
        firstLetter = titleLetter;
        entitiesGrp.push({letter: firstLetter.toUpperCase(), data:[item]});
       }else{
        entitiesGrp.map((i)=>{
            if(i.letter.toUpperCase() === firstLetter.toUpperCase()){
                i.data.push(item);
            }
            return null;
        });
       }
       return null;
     });
    return (
      <>
        {entitiesGrp.map(c => {
          return(<div className="c-entities_list-letter title" key={entitiesGrp.indexOf(c)}>
              <h3 key={c.letter} className="c-entities_letter">{c.letter}</h3>
              {c.data.map(i => <EntityItem key={i.id} entity={i} LinkFactory={LinkFactory} />)}
            </div>);
        })}
      </>
    )
  }
}

export default EntitieList
